import {
  getStaticPagePaths,
  getStaticPageProps,
  StaticPage,
} from '@dreamstack/accentro-contentful'
import { useParams } from '@dreamstack/feature-components'
import { getStaticPathsPlus } from '../lib/next/getStaticPathsPlus'
import { getStaticPropsPlus } from '../lib/next/getStaticPropsPlus'
import { defaultQueries } from '../lib/shared/defaultQueries'

export default function StaticPagePage() {
  const { slug } = useParams()
  return <StaticPage slug={slug} />
}

export const getStaticProps = getStaticPropsPlus({
  queries: defaultQueries,
  getProps: getStaticPageProps,
})

export const getStaticPaths = getStaticPathsPlus(
  getStaticPagePaths({ slugsNotToBuild: ['index', 'news', '404'] })
)
